import { LogLogModel } from "./log-log-model";
import { LogVersaoModel } from "./log-versao-model";

export class LogModel {
    constructor(
        public versao: LogVersaoModel[] = [],
        public log: LogLogModel[] = [],
    ) { }
}